<template>
	<div style="padding: 10px;">
		<el-row :gutter="20">
			<el-col :span="7"> 
				<el-input clearable placeholder="请输入配置名称" v-model="searchInfo.name">
					<template slot="prepend">配置名称</template>
				</el-input>
			</el-col>
			<el-col :span="7"> 
				<el-input clearable placeholder="请输入配置编码" v-model="searchInfo.code">
					<template slot="prepend">配置编码</template>
				</el-input>
			</el-col>
			<el-col :span="9"> 
				<el-button type="primary" @click="searchSysConfig" icon="el-icon-search">搜索</el-button>
				<el-button  icon="el-icon-refresh" @click="clearSearch">重置</el-button>
				<el-button type="primary" icon="el-icon-plus" @click="addStall">新增</el-button>
			</el-col>
		</el-row>
		<div style="margin-top: 10px;">
			<el-table :data="sysconfigList"  style="width: 100%"  height="700">
			    <el-table-column fixed="left" prop="name" label="配置名称"  align="center"></el-table-column>
			    <el-table-column prop="code" label="配置编码"  align="center"></el-table-column>
			    <el-table-column prop="value" label="配置参数"  width="400" align="center"></el-table-column>
				<!-- <el-table-column prop="createtime" label="创建时间"  width="80" align="center"></el-table-column>
				<el-table-column prop="createuser" label="创建人"  width="80" align="center"></el-table-column> -->
				<el-table-column fixed="right" prop="op" label="操作" width="220" align="center">
					<template slot-scope="scope">
						<a @click="goSysConfigDetail(scope.$index, scope.row)" title="详情" style="display:inline-block;cursor:pointer;color: #409EFF;">
							<i class="el-icon-Stall">详情</i>
						</a>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div style="text-align: center;">
			<el-pagination background layout="total, prev, pager, next, sizes" :page-sizes="[10, 20, 50]" :current-page="param.page"
				:page-size="param.pagenum" :total="sysconfigTotal" @size-change="handleSizeChange" @current-change="handleCurrentChange"> </el-pagination>
		</div>
		<el-dialog @close="refrashData" :destroy-on-close="false" :title="detailTitle" width="70%" :visible.sync="detailShow">
			<SysConfigDetail @needRefrash="needRefrash" :select_id="selectID"></SysConfigDetail>
		</el-dialog>
	</div>
</template>

<script>
	import dayjs from 'dayjs'
	import {querySysConfigLists } from '/static/apiUrl.js'
	import SysConfigDetail from './sysconfigdetail'
	export default {
		name : 'sysconfigList',
		data() {
			return {
				detailShow: false,
				editok : false,
				detailTitle: '配置详情',
				selectID: '',	
				searchInfo:{
					name: '',
					code : '',
				},
				param : {
					page : 1,
					pagenum : 10,
				},
				sysconfigTotal : 0,
				sysconfigList : [],				
			}
		},
		mounted() {
			this.initData()
			this.querySysConfig()
		},
		components: {
			SysConfigDetail,
		},
		methods: {
			handleSizeChange(val){
				console.log(val);
				this.param.pagenum = val;
				this.querySysConfig()
			},
			handleCurrentChange(val){
				console.log(val);
				this.param.page = val
				this.querySysConfig()
			},
			initData() {
			},
			searchSysConfig(){
				this.param.page = 1
				this.sysconfigList = []
				this.querySysConfig()
			},
			clearSearch(){
				this.searchInfo.name = ''
				this.searchInfo.code = ''
				this.param.page = 1
				this.querySysConfig()
			},
			querySysConfig(){
				this.sysconfigList = []
				querySysConfigLists({
					name : this.searchInfo.name,
					code : this.searchInfo.code,					
					offset : (this.param.page - 1) * this.param.pagenum,
					limit : this.param.pagenum
				}).then(res => {
					console.log(res)
					if(0 == res.code){
						this.sysconfigTotal = res.data.total
						res.data.data.forEach((sysconfig) => {
							this.sysconfigList.push({
								id : sysconfig.sysconfig_id,
								name : sysconfig.sysconfig_name,
								code : sysconfig.sysconfig_code,
								value: sysconfig.sysconfig_value,	
								createtime: dayjs(sysconfig.stall_createtime).format('YYYY-MM-DD'),
								createuser: sysconfig.sysconfig_createuser,							
							})
						})
					}
				})
			},
			goSysConfigDetail(idx,row){
				this.detailTitle = '配置详情'
				console.log(idx,row)
				this.selectID = row.id
				this.detailShow = true
			},
			addStall(){
				this.detailTitle = "新增配置"
				this.selectID = ''
				this.detailShow = true
			},
			needRefrash(val,isshow){
				console.log(val, isshow)
				this.editok = val
				this.detailShow = isshow
			},
			refrashData() {
				console.log('ddd')
				if(this.editok){
					this.querySysConfig()
				}
			}
		},
		beforeDestroy() {
			
		},
	}
</script>

<style scoped>
	
</style>